<script lang="ts">
	import Badge from '$lib/atoms/Badge.svelte'
	import { t } from '$i18n/i18n'
</script>

<div class="danger-badge">
	<Badge text={$t('Analytics.danger.badge')} uppercase></Badge>
</div>

<style>
	/* both reasons read as one severity, so they share the red of the danger scale */
	.danger-badge {
		display: contents;

		--badge-wrapper-bg: var(--color-highlight-red-200);
		--badge-wrapper-color: var(--color-highlight-red-800);
	}
</style>
